import { FC, useEffect, useRef, useState } from 'react'
import { useLayout } from '../../../_metronic/layout/core'
import { useParams } from 'react-router-dom'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../setup'
import { UserModel } from '../../modules/auth/models/UserModel'
import { MyTeamWrapper } from './MyTeamWrapper'

const MyTeamPage: FC = () => {
    const user = useSelector<RootState>(
        ({ auth }) => auth.user,
        shallowEqual
    ) as UserModel
    const { userId } = useParams<{ userId:string }>()
    const { config, setLayout } = useLayout()
    const restoreRef = useRef(config)

    useEffect(() => {
        restoreRef.current = config
        setLayout({
            ...config,
            header: { ...config.header, display: true },
            aside: { ...config.aside, display: true },
            toolbar: { ...config.toolbar, display: false },
            footer: { ...config.footer, display: true },
        })
        return () => {
            setLayout(restoreRef.current)
        }
    }, [])

    return (
        <MyTeamWrapper userTeamId={Number(userId)} firstName={user?.firstName} lastName={user.lastName} />
    )
}

export { MyTeamPage }
